// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"650":"971ddbb086019843","674":"758e1fe335c74893"}[chunkId] + ".css";
};